<template>
	<div class="row border border-warning p-md-4">
		<h4 v-if="city.name">Set Hotels and vehicles for {{ city.name }}</h4>
		<div :class="data.sightEnabled ? 'col-sm-6 my-4':'col-sm-12 my-4'">
			<div class="form-check form-switch">
				<input
					class="form-check-input"
					v-model="data.sightEnabled"
					type="checkbox"
					id="sightCheck"
					@change="checkToRemove(data.sightEnabled)"
				/>
				<label class="form-check-label text-dark" for="sightCheck"
					>Add Hotels mapped with custom places</label
				>
			</div>
		</div>
		<div v-if="data.sightEnabled" class="col-sm-6">
			<BaseInput
				name="Sight Count"
				label="Sight Count"
				type="number"
				v-model="sightCountRef"
				:min="1"
				:required="true"
				class="form-control form-control-lg dashInput"
				rules="required"
			/>
		</div>
		<div class="col-sm-12">
			<SightHotel v-for="sightStay in data.staySights"
				:key="sightStay.id" 
				:defaultData="sightStay"
				:hotels="multiSelectState.hotelsSelect"
				:sights="multiSelectState.sightsSelect"
				:stay="stay"
				@add-data="addComponentStateData"
				/>
		</div>
		

		<div v-if="!data.staySights.length" class="form-group col-sm-6 mb-5">
			<BaseMultiSelect
				@update:value="setHotels"
				:options="multiSelectState.hotelsSelect"
				:defaultData="data.hotels"
				mode="tags"
				rules="required"
				name="Hotels"
			/>
		</div>
		<div :class="`${data.staySights.length ? 'col-sm-4' : 'col-sm-6' } form-group  mb-5 `">
			<BaseMultiSelect
				@update:value="setVehicle"
				:options="multiSelectState.vehiclesSelect"
				:defaultData="data.vehicle"
				rules="required"
				name="Vehicle"
			/>
		</div>
		<div 
		v-if="!id"
		:class="data.staySights.length ?'col-sm-4 form-group mb-5 position-relative':'col-sm-6 form-group mb-5 position-relative'">
			<BaseInput
				name="Off Season Price"
				label="Off Season Price"
				type="number"
				v-model="data.offSeasonPrice"
				:min="0"
				class="form-control form-control-lg dashInput"
				rules="required"
			/>
		</div>
		<div v-if="!id" :class="`${ data.staySights.length ? 'col-sm-4' : 'col-sm-6' } form-group mb-5 position-relative`">
			<BaseInput
				name="Season Price"
				label="Season Price"
				type="number"
				v-model="data.seasonPrice"
				:min="0"
				class="form-control form-control-lg dashInput"
				rules="required"
			/>

			<span

				@click="removeState()"
				class="mx-2 position-absolute top-100 start-100 translate-middle badge rounded-pill bg-danger cursor-pointer"
				><i class="bi bi-x"></i
			></span>
		</div>
	</div>
</template>
<script>
	import { reactive, ref, watch, onMounted, inject } from "vue";
	import API from "@/config/api.js";
	import toast from "@/config/toast";
	import Helper from "@/helpers/dataHelper";

	import BaseMultiSelect from "./BaseMultiSelect.vue";
	import BaseInput from "./BaseInput.vue";
	import SightHotel from "./sightHotel.vue";

	export default {
		name: "PackageDeal",
		props: {
			id: { type: Number },
			dealName: { type: String },
			defaultData: { type: [Object, Boolean, String], default: false },
			city: { type: Object, default: {} },
			stay: { type: Number, default: 0 },
			sightCount: { type: Number, default: 0 },
		},
		components: {
			BaseMultiSelect,
			BaseInput,
			SightHotel,
		},
		emits: ["updateData", "removeData"],

		setup: (props, { emit }) => {

			const data = reactive({
				id: props.id,
				city: props.city,
				cityStay: props.stay,
				sightEnabled: false,
				staySights: [],
				hotels: [],
				vehicle: null,
				seasonPrice: 0,
				offSeasonPrice: 0,
			});

			const sightCountRef = ref(props.sightCount || 0);

			const addComponentState = (count, action) => {
				for (let i = 0; i < count; i++) {
					let obj = {
						id: (data.staySights.length == 0 ? 1 : data.staySights.length + 1),
						stayPlace: "",
						hotels: [],
						stay: 0,
					}
					if (action) data.staySights = [...data.staySights, { ...obj }];
					else if (!action) data.staySights.pop();
				}
			}

			const addComponentStateData = (stateData) => {			
				data.staySights = data.staySights.map(
					(staySight) => {
						if (staySight.id === stateData.id) return (staySight = { ...stateData })
						else return staySight
					}
				)
			}

			const checkToRemove = (bool) => {
				if (!bool) {
					data.staySights = [];
					sightCountRef.value = 0;
				}

			}

			//setting sight count 

			watch(sightCountRef, (newValue, preValue) => {
				let addCount;
				if (newValue === 0) {
					return data.staySights = [];
				} else if (preValue !== newValue && preValue < newValue) {
					addCount = newValue - preValue;
					addComponentState(addCount, true);
				} else if (preValue !== newValue && preValue > newValue) {
					
					addCount = preValue - newValue;
					addComponentState(addCount, false);
				}
			});

			if (
				typeof props.defaultData === "object" &&
				Object.keys(props.defaultData).length
			) {

				Object.keys(data).map(
					(key) => (data[key] = props.defaultData[key] || data[key]),
				);

				if (data.hotels.length) {
					const hotels = data.hotels.map(hotel => hotel._id);
					data.hotels = [...hotels];
				}
				if (data.staySights.length) {
					data.staySights.map(sight => {
						if (sight.hotels.length) (sight.hotels = sight.hotels.map(hotel => hotel._id))
						delete sight._id;
					})	
				}
				if (data.vehicle) {
					data.vehicle = data.vehicle._id;
				}

				// data.hotels = [...props.defaultData.hotels];
				// data.vehicle = props.defaultData.vehicle;
				// data.price = props.defaultData.price;
			}

			const multiSelectState = reactive({
				hotels: [],
				hotelsSelect: [],
				vehicles: [],
				vehiclesSelect: [],
				cities: [],
				citiesSelect: [],
			});

			watch(data, (preValue, newValue) => {
				if (data.vehicle && (data.hotels.length || data.staySights.length)) {
					emit("updateData", data);
				}
			});


			const getHotels = async (query) => {
				try {
					const response = await API.privateRequest.get(`hotels?${query}&deal=${props.dealName}`);
					multiSelectState.hotels = response.data.data;
					const hotels = response.data.data.map((hotel) => ({
						label: `${hotel.name} (${hotel.city.name} - ${hotel.starRating}⭐ ${hotel.hotelType})`,
						value: hotel._id,
					}));
					multiSelectState.hotelsSelect = [...hotels];
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error !";
					}
					console.log("error in hotel fetch");

					toast.error(message, true);
				}
			};

			const getVehicles = async () => {
				try {
					const response = await API.privateRequest.get("vehicles");
					const vehicles = response.data.data.map((vehicle) => ({
						value: vehicle._id,
						label: vehicle.vehicleType,
					}));
					multiSelectState.vehicles = response.data.data;
					multiSelectState.vehiclesSelect = vehicles;
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error !";
					}
					console.log("error in vehicle fetch");

					toast.error(message, true);
				}
			};

			const setHotels = (payload) => {
				data.hotels = [...payload];
			};
			const setVehicle = (payload) => {
				if (!payload) {
					data.vehicle = null;
					return;
				}
				data.vehicle = payload;
			};

			const removeState = () => {
				
				data.id = props.id
				data.city = props.city
				data.cityStay = props.stay
				data.sightEnabled = false
				data.staySights = []
				data.hotels = []
				data.vehicle = null
				data.seasonPrice = 0
				data.offSeasonPrice = 0

				emit("updateData", data);
			};

			onMounted(() => {
				getHotels(`city=${props.city.name}`);
				getVehicles();
			});

			return {
				data,
				sightCountRef,
				multiSelectState,

				setVehicle,
				setHotels,
				removeState,
				addComponentStateData,
				checkToRemove,
			};
		},
	};
</script>
